export default __webpack_public_path__ + "static/media/sms.4c427daa.png";